<script setup>
import { onUnmounted } from 'vue'

const emit = defineEmits(['back'])

onUnmounted(() => {
  localStorage.setItem('cardStep', 1)
})

const handleBack = () => {
  emit('back')
}
</script>

<template>
  <div class="card p-4">
    <div class="card-body d-flex flex-column align-items-center justify-content-center" style="min-height:180px;">
        <div class="d-flex align-items-center justify-content-center">
            <div class="success-icon">✔</div>
            <div class="success-title ms-3">Application recieved</div>
        </div>
      <div class="success-desc">Thank you for your application we'll be in touch shortly to finalise the process.</div>
      <button class="back-to-start-btn" @click="handleBack">
        Back
      </button>
    </div>
  </div>
</template>

<style scoped>
.success-icon {
  font-size: 48px;
  color: #00c962;
  margin-bottom: 5px;
}
.success-title {
  font-family: 'Euclid Square', sans-serif;
  font-weight: 600;
  font-size: 26px;
  color: #12223b;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
}
.success-desc {
  color: #1a2a3a;
  font-size: 1rem;
  margin-top: 4px;
  text-align: center;
}

.back-to-start-btn {
  background: #00c962;
  color: #051C2C;
  border: none;
  border-radius: 24px;
  padding: 12px 32px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  margin-top: 24px;
  transition: background 0.2s;
}

.back-to-start-btn:hover {
  background: #00b555;
  color: #fff;
}
</style> 